var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { useToolStore } from "@/stores/toolStore";
import localize from "@/utils/localization";
import { errorMessageAsString, rethrowSimple } from "@/utils/simple-error";
import { types_to_icons } from "./utilities";
import LoadingSpan from "../LoadingSpan.vue";
import FavoritesButton from "./Buttons/FavoritesButton.vue";
import PanelViewMenu from "./Menus/PanelViewMenu.vue";
import ToolBox from "./ToolBox.vue";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolPanel',
    props: {
        workflow: { type: Boolean, default: false },
        editorWorkflows: { type: Array, default: null },
        dataManagers: { type: Array, default: null },
        moduleSections: { type: Array, default: null },
    },
    emits: ["onInsertTool", "onInsertModule", "onInsertWorkflow", "onInsertWorkflowSteps"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretDown);
        const arePanelsFetched = ref(false);
        const toolStore = useToolStore();
        const { currentPanelView, defaultPanelView, isPanelPopulated, loading, panel, panelViews, currentPanel } = storeToRefs(toolStore);
        const loadingView = ref(undefined);
        const query = ref("");
        const showAdvanced = ref(false);
        const errorMessage = ref(undefined);
        initializeToolPanel();
        function initializeToolPanel() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield toolStore.fetchPanelViews();
                    yield initializeTools();
                }
                catch (error) {
                    console.error(error);
                    errorMessage.value = errorMessageAsString(error);
                }
                finally {
                    arePanelsFetched.value = true;
                }
            });
        }
        watch(() => currentPanelView.value, () => {
            query.value = "";
        });
        // if currentPanelView ever becomes null || "", load tools
        watch(() => currentPanelView.value, (newVal) => __awaiter(this, void 0, void 0, function* () {
            if ((!newVal || !panel.value[newVal]) && arePanelsFetched.value) {
                yield initializeTools();
            }
        }));
        const toolPanelHeader = computed(() => {
            var _a, _b;
            if (showAdvanced.value) {
                return localize("Advanced Tool Search");
            }
            else if (loading.value && loadingView.value) {
                return localize(loadingView.value);
            }
            else if (currentPanelView.value !== "default" &&
                panelViews.value &&
                ((_a = panelViews.value[currentPanelView.value]) === null || _a === void 0 ? void 0 : _a.name)) {
                return localize((_b = panelViews.value[currentPanelView.value]) === null || _b === void 0 ? void 0 : _b.name);
            }
            else {
                return localize("Tools");
            }
        });
        const viewIcon = computed(() => {
            var _a, _b;
            if (showAdvanced.value) {
                return "search";
            }
            else if (currentPanelView.value !== "default" &&
                panelViews.value &&
                typeof ((_a = panelViews.value[currentPanelView.value]) === null || _a === void 0 ? void 0 : _a.view_type) === "string") {
                const viewType = (_b = panelViews.value[currentPanelView.value]) === null || _b === void 0 ? void 0 : _b.view_type;
                return viewType ? types_to_icons[viewType] : null;
            }
            else {
                return null;
            }
        });
        function initializeTools() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield toolStore.fetchTools();
                    yield toolStore.initCurrentPanelView(defaultPanelView.value);
                }
                catch (error) {
                    console.error("ToolPanel - Intialize error:", error);
                    errorMessage.value = errorMessageAsString(error);
                    rethrowSimple(error);
                }
            });
        }
        function updatePanelView(panelView) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                loadingView.value = (_a = panelViews.value[panelView]) === null || _a === void 0 ? void 0 : _a.name;
                yield toolStore.setCurrentPanelView(panelView);
                loadingView.value = undefined;
            });
        }
        function onInsertTool(toolId, toolName) {
            emit("onInsertTool", toolId, toolName);
        }
        function onInsertModule(moduleName, moduleTitle) {
            emit("onInsertModule", moduleName, moduleTitle);
        }
        function onInsertWorkflow(workflowId, workflowName) {
            emit("onInsertWorkflow", workflowId, workflowName);
        }
        function onInsertWorkflowSteps(workflowId, workflowStepCount) {
            emit("onInsertWorkflowSteps", workflowId, workflowStepCount);
        }
        return { __sfc: true, props, emit, arePanelsFetched, toolStore, currentPanelView, defaultPanelView, isPanelPopulated, loading, panel, panelViews, currentPanel, loadingView, query, showAdvanced, errorMessage, initializeToolPanel, toolPanelHeader, viewIcon, initializeTools, updatePanelView, onInsertTool, onInsertModule, onInsertWorkflow, onInsertWorkflowSteps, FontAwesomeIcon, LoadingSpan, FavoritesButton, PanelViewMenu, ToolBox, Heading };
    }
});
